const KEY = 'poneva.billingDraft';
export interface BillingDraft {
  text: string;
  threadId: string;
  ownerId: string;
  send: false;
}

export class BillingDraftError extends Error {
  constructor(public readonly reason: 'attachments' | 'storage') {
    super(`billing_draft_${reason}`);
  }
}

// Files remain in the composer until the user removes them explicitly. Never
// unload a draft with attachments that sessionStorage cannot restore.
export function stashBillingDraft(
  text: string,
  threadId: string,
  ownerId: string,
  hasAttachments = false,
) {
  if (hasAttachments) throw new BillingDraftError('attachments');
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ text, threadId, ownerId, send: false }));
  } catch {
    throw new BillingDraftError('storage');
  }
}

export function consumeBillingDraft(): BillingDraft | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    if (!raw) return null;
    const value = JSON.parse(raw);
    return typeof value.text === 'string' &&
      typeof value.threadId === 'string' &&
      typeof value.ownerId === 'string' &&
      value.ownerId.length > 0
      ? { text: value.text, threadId: value.threadId, ownerId: value.ownerId, send: false }
      : null;
  } catch {
    return null;
  }
}

// Called only after the server session resolves, before seeding any thread or
// restoring any text. A payment return must never bridge two accounts.
export function billingDraftForUser(
  draft: BillingDraft | null,
  userId: string | null,
): BillingDraft | null {
  return userId && draft?.ownerId === userId ? draft : null;
}
